// ! Copyright (c) 2024, Brandon Ramirez, brr.dev

import { Contentful } from '@brr-dev/contentful';

// TODO install T3 env handlers
export const ContentfulAPI = new Contentful.ContentfulDeliveryAPI({
    spaceID: process.env.REACT_APP_CONTENTFUL_API_SPACE_ID ?? '',
    environment: process.env.REACT_APP_CONTENTFUL_API_ENVIRONMENT ?? '',
    token: process.env.REACT_APP_CONTENTFUL_API_ACCESS_TOKEN ?? '',
});
